var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AsiPageTitle',{attrs:{"title":_vm.$t('shoppingList.plural'),"icon":_vm.icons.shoppingList}}),_c('ShoppingListList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }